import { getIsUiBlocked } from '../getIsUiBlocked'

export const getShowLoading = state =>
    state.feedback.showLoader || getIsUiBlocked(state)



// WEBPACK FOOTER //
// ./src/redux/selectors/feedback/getShowLoading.js